import { cn } from "@bcc/lib/utils";
import { ChevronRight } from "lucide-react";
import React from "react";
import { setStepProgressItemTestId, setStepProgressTestId } from "./step-progress.utils";

type Step = "select" | "configure" | "review";

interface StepProgressProps {
  currentStep: Step;
  steps: Array<{ key: Step; label: string; number: number }>;
  testId?: string;
  className?: string;
}

export function StepProgress({ currentStep, steps, testId, className }: StepProgressProps) {
  return (
    <div data-testid={testId ?? setStepProgressTestId("default")} className={cn("flex items-center gap-2", className)}>
      {steps.map((step, index) => (
        <React.Fragment key={step.key}>
          <div
            data-testid={setStepProgressItemTestId(step.key)}
            className={cn("flex items-center gap-2", step.key === currentStep ? "text-primary" : "text-muted-foreground")}
          >
            <div
              className={cn(
                "flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium",
                step.key === currentStep ? "bg-primary text-primary-foreground" : "bg-muted"
              )}
            >
              {step.number}
            </div>
            <span className="text-sm font-medium">{step.label}</span>
          </div>
          {index < steps.length - 1 && <ChevronRight className="h-4 w-4 text-muted-foreground" />}
        </React.Fragment>
      ))}
    </div>
  );
}
